import React, { useEffect, useState } from 'react';
import './NavBar.style.scss';
import { useNavBar } from '../../../Contexts/navbar.items.context.jsx';
import { useAllThingsLists } from '../../../Contexts/allThingsList.context.jsx';
import NavPill from '../../NavItems/NavPill/NavPill.component.jsx';
import FilterBox from '../../Universals/filterBox/filterBox.component.jsx';
import { usePlayer } from '../../../Contexts/playerData.context.jsx';
import { useBoxContext } from '../../../Contexts/boxData.context.jsx';
import { getUserFromToken } from '../../../utils/functions.ts';

const NavigationBar = () => {
     const { searchedListName, nipCount, usaCount, gloCount, vCount, activeSideButton, updateActiveSideButton } = useNavBar();
     const { filterBoxValue, isListPillFiltered, isListFiltered, setIsListPillFiltered } = useAllThingsLists();
     const { playerData, playerDataLength, setActiveFilter, activeFilter } = usePlayer();
     const { setNoteBoxOpen } = useBoxContext();

     const mainFields = ["Reset", "Last Name", "First Name", "Gen Position", "School", "CFL Team", "NFL Team"];
     const [hasAdmin, setHasAdmin] = useState(false);
     // eslint-disable-next-line
     const noteFields = [...mainFields, "Note"];
     // eslint-disable-next-line
     const scoutFields = [...mainFields, "Grade (>=)", "Calc Grade (>=)"];
     // eslint-disable-next-line
     const [fields, setFields] = useState(mainFields);
     const [showFields, setShowFields] = useState({});
     const hasPlayers = Array.isArray(playerData) ? playerData.length > 0 : playerDataLength > 0;

     useEffect(() => {
          let isMounted = true;

          const loadUserDisplaySettings = async () => {
               const user = await getUserFromToken();
               if (!isMounted) return;

               setHasAdmin(user?.userContactLevel === '1');
               setShowFields(user?.showFields || {});
          };

          loadUserDisplaySettings();

          const handleFocus = () => loadUserDisplaySettings();
          window.addEventListener('focus', handleFocus);

          return () => {
               isMounted = false;
               window.removeEventListener('focus', handleFocus);
          };
     }, []);

     const isShowFieldNo = (field) => String(showFields?.[field] || '').toLowerCase() === 'no';

     const NavBarPushed = (boxName) => {
          setNoteBoxOpen(false);
          updateActiveSideButton(prev =>
               prev === boxName ? '' : boxName
          );
     };


     const pillClicked = (pillValue) => {
          if (!isListFiltered) {
               if (activeFilter === pillValue) {
                    setActiveFilter('');
                    setIsListPillFiltered(false);
               } else {
                    setActiveFilter(pillValue);
                    setIsListPillFiltered(true);
               }
          }

     }

     return (
          <div className='nav-bar'>
               <div className='left'>
                    <>
                         <FilterBox
                              // key={filterResetKey}
                              displayValue={filterBoxValue}
                              chosenFields={fields}
                              readOnly={isListPillFiltered}  // 🔥 Ensure it's a boolean
                         />

                         <div className="ms-2 me-2 text-light fs-8" style={{ minWidth: "75px" }}>{playerDataLength} Records</div>

                         <div className="d-flex gap-1" style={{ marginLeft: "5px" }}>

                              {/* nav pills are deal with in pageContent */}

                              <NavPill
                                   theTitle="Nationals"
                                   isPillFiltered={activeFilter === 'N'}
                                   theValue={nipCount}
                                   buttonColor={isListFiltered ? "grey" : activeFilter === 'N' ? "orange" : "var(--danger)"}
                                   onClick={() => pillClicked('N')}
                                   isDisabled={isListFiltered}
                              />
                              <NavPill
                                   theTitle="American"
                                   isPillFiltered={activeFilter === 'U'}
                                   theValue={usaCount}
                                   buttonColor={isListFiltered ? "grey" : activeFilter === 'U' ? "orange" : "var(--primary)"}
                                   onClick={() => pillClicked('U')}
                                   isDisabled={isListFiltered}
                              />
                              <NavPill
                                   theTitle="Globals"
                                   isPillFiltered={activeFilter === 'G'}
                                   theValue={gloCount}
                                   buttonColor={isListFiltered ? "grey" : activeFilter === 'G' ? "orange" : "#bae97480"}
                                   onClick={() => pillClicked('G')}
                                   isDisabled={isListFiltered}
                              />
                              <NavPill
                                   theTitle="Nationalized Americans"
                                   isPillFiltered={activeFilter === 'V'}
                                   theValue={vCount}
                                   buttonColor={isListFiltered ? "grey" : activeFilter === 'V' ? "orange" : "var(--brown)"}
                                   onClick={() => pillClicked('V')}
                                   isDisabled={isListFiltered}
                              />
                         </div>

                         <div className="ms-2 text-light fs-8">{searchedListName}</div>
                    </>
               </div>
               <div className="right">
                    {!hasPlayers ? (
                         <div className="nav-empty-state">No players selected</div>
                    ) : (
                         <>
                              {hasAdmin && (
                                   <div
                                        className={`btn-long ${activeSideButton === 'TomBox' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                        onClick={() => NavBarPushed('TomBox')}
                                   >
                                        Add/Edit
                                   </div>
                              )}
                              <div
                                   className={`btn-long ${activeSideButton === 'draftboard' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                   onClick={() => window.open('https://www.fbxchange.com/DB2020/', '_blank')}
                              >
                                   Depth
                              </div>
                              {!isShowFieldNo('showOprah') && (
                                   <div
                                        className={`btn-long ${activeSideButton === 'Overview' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                        onClick={() => NavBarPushed('Overview')}
                                   >
                                        Overview
                                   </div>
                              )}
                              {!isShowFieldNo('showEXPORT') && (
                                   <div className="d-flex justify-content-end align-items-center">
                                        <div
                                             className={`btn-long ${activeSideButton === 'Export' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                             onClick={() => NavBarPushed('Export')}
                                        >
                                             Export
                                        </div>
                                   </div>
                              )}
                              {!isShowFieldNo('showHWS') && (
                                   <div
                                        className={`btn-long ${activeSideButton === 'hdbox' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                        onClick={() => NavBarPushed('hdbox')}
                                   >
                                        Hard Data
                                   </div>
                              )}
                              {!isShowFieldNo('showTRANS') && (
                                   <div
                                        className={`btn-long ${activeSideButton === 'transactions' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                        onClick={() => NavBarPushed('transactions')}
                                   >
                                        Transactions
                                   </div>
                              )}
                              {!isShowFieldNo('showREPORT') && (
                                   <div
                                        className={`btn-long ${activeSideButton === 'reports1' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                        onClick={() => NavBarPushed('reports1')}
                                   >
                                        Reports
                                   </div>
                              )}
                              {!isShowFieldNo('showNOTE') && (
                                   <div
                                        className={`btn-long ${activeSideButton === 'notes' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                        onClick={() => NavBarPushed('notes')}
                                   >
                                        Notes
                                   </div>
                              )}
                              {!isShowFieldNo('showREPORT') && (
                                   <div
                                        className={`btn-long ${activeSideButton === 'Files' ? 'btn-warning' : 'bg-light text-dark'} btn-hover-warning`}
                                        onClick={() => NavBarPushed('Files')}
                                   >
                                        Files
                                   </div>
                              )}
                         </>
                    )}
               </div>

          </div>
     );
};

export default NavigationBar;
